export default "__VITE_ASSET__6796bc98__"